<template>
    <div>
        <v-dialog v-model="dialog_filter_month" no-click-animation scrollable persistent max-width="280px" content-class="full-height" transition="dialog-bottom-transition">
            <v-card>
                <v-subheader>
                    Select Month

                    <v-spacer></v-spacer>
                    <v-menu>
                        <template v-slot:activator="{ on, attrs }">
                            <div class="subtitle-text dark-opacity-color" v-bind="attrs" v-on="on" cursor-pointer>
                                FY {{selectedFiscalYear.toString().substring(2)}}-{{(selectedFiscalYear+1).toString().substring(2)}}
                                <v-icon class="subtitle-icon">arrow_drop_down</v-icon>
                            </div>
                        </template>

                        <v-list dense nopadding>
                            <template v-for="(item, index) in fiscalYears">
                                <v-list-item @click="selectedFiscalYear=item.value" :key="index" v-if="fn_checkOpeningDate(item.value)">
                                    <v-list-item-content>
                                        <v-list-item-title>{{item.title}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </v-subheader>
                <v-card-text class="pa-0">

                    <v-alert type="info" style="font-size:12px" dense :value="true">Showing months between opening date and end of this fiscal year!</v-alert>

                    <v-list class="pa-0">
                        <v-list-item v-for="(item, index) in filteredMonths" :key="index" @click="selectPeriod('monthly', item.month, selectedFiscalYear)">
                          <v-list-item-title>{{ item.name }} {{item.month > 3 ? selectedFiscalYear : (selectedFiscalYear + 1)}}</v-list-item-title>
                        </v-list-item>
                    </v-list>

                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="blue darken-1" text @click="closeDialogWeb">close</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
    </div>
</template>

<script>
    export default{
        props:['selectPeriod'],
        data(){
            return{
                dialog_filter_month:false,
                selectedFiscalYear:null,
                fiscalYears:[
                    // {"title":"FY 2021", "value":2021},
                    // {"title":"FY 2022", "value":2022}
                    {"title":"FY 22-23", "value":2022},
                    {"title":"FY 23-24", "value":2023},
                    {"title":"FY 24-25", "value":2024},
                    {"title":"FY 25-26", "value":2025},
                    {"title":"FY 26-27", "value":2026}
                ],
                months:[
                    {"name":"April", "month":4},
                    {"name":"May", "month":5},
                    {"name":"June", "month":6},
                    {"name":"July", "month":7},
                    {"name":"August", "month":8},
                    {"name":"September", "month":9},
                    {"name":"October", "month":10},
                    {"name":"November", "month":11},
                    {"name":"December", "month":12},
                    {"name":"January", "month":1},
                    {"name":"February", "month":2},
                    {"name":"March", "month":3},
                ]
            }
        },
        methods:{
            // openDialogWeb: function () {
            //     let currentDate = new Date();
            //     let currentYear = currentDate.getFullYear();

            //     let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
            //     let openingYear = openingDate.getFullYear();
            //     let openingMonth = openingDate.getMonth() + 1;

            //     if(openingMonth<=3 && currentYear <= openingYear){
            //         this.selectedFiscalYear = openingYear - 1;
            //     }
            //     else{
            //         this.selectedFiscalYear = openingYear;
            //     }
            //     this.dialog_filter_month = true;
            // },
            openDialogWeb: function () {
                let maxYear = new Date(this.$root.maxDateSelection).getFullYear();

                let currentDate = new Date();
                let currentYear = currentDate.getFullYear() > maxYear ? maxYear : currentDate.getFullYear();
                let currentMonth = currentDate.getMonth() + 1;

                let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
                let openingYear = openingDate.getFullYear();
                let openingMonth = openingDate.getMonth() + 1;

                let openingFY = openingMonth <= 3 ? (openingYear - 1) : openingYear;
                let currentFY = currentMonth <= 3 ? (currentYear - 1) : currentYear;

                this.selectedFiscalYear = currentFY > openingFY ? currentFY : openingFY;

                this.dialog_filter_month = true;
            },
            closeDialogWeb: function () {
                this.dialog_filter_month = false;
            },
            fn_checkOpeningDate: function(item){
                let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
                let openingMonth = openingDate.getMonth() + 1;
                let openingYear = openingDate.getFullYear();
                openingMonth <= 3 ? openingYear = openingYear - 1 : '';
                if(item >= openingYear){
                    return true;
                }
                else{
                    return false;
                }
            },
            // fn_disbaleMonth: function(month, year){
            //     let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
            //     let openingMonth = openingDate.getMonth() + 1;
            //     let openingYear = openingDate.getFullYear();
            //     if(month < openingMonth || year < openingYear){
            //         return true;
            //     }
            //     else{
            //         return false;
            //     }
            // }
        },
        computed:{
            filteredMonths: function(){
                let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
                let openingMonth = openingDate.getMonth() + 1;
                let openingYear = openingDate.getFullYear();
                openingMonth <= 3 ? openingYear = openingYear - 1 : '';
                let items = this.months.filter(item=>{
                    if(openingYear == this.selectedFiscalYear){
                        if(openingMonth <= 3){
                            // return item.month >= openingMonth && item.month <= 3;
                            return item.month <= 3 && item.month >= openingMonth;
                        }
                        else{
                            return item.month >= openingMonth || item.month <= 3;
                        }
                    }
                    else if(openingYear < this.selectedFiscalYear){
                        return true;
                    }
                });
                return items;
            }
        }
    }
</script>